import React from 'react';
import { motion } from 'framer-motion';
import RatingScale from './RatingScale';

const ratingDefinitions = [
  { value: 0, label: 'Not familiar' },
  { value: 1, label: 'Aware but inexperienced' },
  { value: 2, label: 'Novice / learning with supervision' },
  { value: 3, label: 'Entry-to-practice / practices with some support' },
  { value: 4, label: 'Independent / skilled' },
  { value: 5, label: 'Advanced / can teach or supervise' }
];

const CompetencySection = ({ section, ratings, comments, onRatingChange, onCommentChange }) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      className="space-y-6"
    >
      <div className="mb-6">
        <h2 className="text-xl font-bold text-brand-primary mb-2">{section.title}</h2>
        {section.description && (
          <p className="text-gray-600 leading-relaxed">{section.description}</p>
        )}
      </div>

      <div className="space-y-8">
        {section.items.map((item, index) => (
          <div key={item.id} className="bg-gray-50 rounded-lg p-6 border border-gray-200 hover:border-brand-secondary/30 transition-colors">
            <div className="mb-4">
              <h3 className="text-lg font-semibold text-brand-primary mb-2">
                {section.id}.{index + 1} {item.title}
              </h3>
              <p className="text-gray-600 leading-relaxed text-sm">{item.description}</p>
            </div>

            <div className="space-y-6">
              {/* Rating Scale Legend */}
              <div className="bg-white p-4 rounded-xl border border-brand-light shadow-sm">
                <p className="text-[10px] font-bold text-brand-secondary uppercase tracking-widest mb-3">
                  Scale Reference
                </p>
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-x-6 gap-y-2">
                  {ratingDefinitions.map((def) => (
                    <div key={def.value} className="flex items-start gap-2 text-xs leading-tight">
                      <span className="flex items-center justify-center font-bold text-brand-primary bg-brand-light rounded-md w-5 h-5 flex-shrink-0">
                        {def.value}
                      </span>
                      <span className="text-gray-500 font-medium">{def.label}</span>
                    </div>
                  ))}
                </div>
              </div>

              <div>
                <label className="block text-sm font-semibold text-gray-700 mb-3">
                  Select Your Rating:
                </label>
                <RatingScale
                  value={ratings[`${section.id}-${item.id}`] || 0}
                  onChange={(rating) => onRatingChange(section.id, item.id, rating)}
                />
              </div>

              <div>
                <label className="block text-sm font-semibold text-gray-700 mb-2">
                  Notes & Examples:
                </label>
                <textarea
                  value={comments[`${section.id}-${item.id}`] || ''}
                  onChange={(e) => onCommentChange(section.id, item.id, e.target.value)}
                  placeholder="Provide supporting evidence or specific examples for your rating..."
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-brand-primary focus:border-transparent transition-all resize-none text-sm"
                  rows="3"
                />
              </div>
            </div>
          </div>
        ))}
      </div>
    </motion.div>
  );
};

export default CompetencySection;